module.exports = __webpack_public_path__ + "img/explorer-gray.50193227.svg";